<template>
    <div>
        <!-- <Nav bgColor="#FFFFFF" /> -->
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <span class="text-uppercase text-black  display-1 home-text mx-2 text-center">Subscribe</span>
            </div>
        </div>
        <div class="col-md-10 offset-md-1 site-black-bg">
                <div class="text-white h2 text-uppercase pb-2 p-4"> Join Our Mailing List</div>
                <div class="text-white h6 py-2"> Be the first to hear about our special events and classes. Rest
                    assured, we only email about once a month! </div>

                <form v-if="!formSubmitted" @submit.prevent="submitEmail" class="styled-form py-2">
                    <input type="text" placeholder="Your Email" class="email-input" v-model="email" />

                    <button type="submit" class="submit-button">
                        <i class="fa-solid fa-arrow-right d-none d-sm-block"></i>
                    </button>
                </form>
                <div v-if="formSubmitted" @submit.prevent="submitEmail" class="text-white py-2"> Thank you for singing
                    up!</div>
            </div>

        <!-- <AllClasses /> -->
        <!-- <PageSections :sectionId="2" /> -->
        <!-- <div class="container-fluid" style="background-color: black;">
         <div class="row chalk-row">
             <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                 <div class="text-center chalk-outline">
                     <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                     <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                 </div>
                 <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                     storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                     comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                     decision-making skills.</div>
                 <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                     offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                 <div class="pt-5">
                     <div class="btn ms-2 text-uppercase text-white chalk-btn "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Learn More</div>
                     <div class="btn ms-2 text-uppercase text-white chalk-btn  "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                 </div>

             </div>

         </div>

     </div>
     <div class="container-fluid" style="background-color:rgb(246,206,55);">
         <div class="row flex-row-reverse">
             <div class="col-md-6">
                 <div class="our-story">
                     <div class='h1 text-uppercase'> Our Story</div>
                     <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                         Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                         Judkins sought a creative environment that challenged and fulfilled us artistically. They
                         knew we were capable of more and wanted to push us to new heights. They realized short-form
                         wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                         Madison followed Parmentier to do something new and amazing.</div>
                     <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                         character building, or pure wite, every performer is a master.</div>
                     <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Learn More
                     </div>
                 </div>
             </div>
             <div class="col-md-6">
                 <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                     class="img-fluid w-100 d-md-inline" alt="globe" />
             </div>
         </div>

     </div> -->
        <!-- <Footer /> -->

    </div>



</template>

<script>
// import axios from "axios";
/* global grecaptcha */

export default {
    data() {
        return {
            email: "",
            formSubmitted: false
        };
    },
    mounted() {
        const waitForRecaptcha = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.execute) {
                clearInterval(waitForRecaptcha);
                this.recaptchaReady = true;
            }
        }, 100);
    },
    methods: {
        async submitEmail() {
            if (!this.recaptchaReady) {
                console.error("reCAPTCHA not ready yet");
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.email)) {
                console.error("Invalid email format");
                alert("Please enter a valid email address.");
                return;
            }

            try {
                const token = await grecaptcha.execute('6LcaASsrAAAAADvXXVZOpweAdkZihozWT9yRjLef', { action: 'submit' });

                const response = await fetch("https://hooks.atlasimprov.com/verify-recaptcha", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({
                        email: this.email,
                        recaptchaToken: token,
                    }),
                });

                const result = await response.json();
                console.log("Success:", result);
            } catch (err) {
                console.error("reCAPTCHA or fetch error:", err);
            }
        }
    }

}
</script>
